import React, { Component, PropTypes } from 'react';
import Highcharts from 'highcharts';
import _ from 'lodash';
import { observer, inject } from 'mobx-react';
import { action, observable } from 'mobx';
import moment from 'moment';
import Form, { FormBody, DateInput, SelectInput, FormActions, TextInput } from '../Form';
import * as api from '../../actions/api';
import GraphView from '../GraphView';
import Spinner from '../Spinner';
import { getDisplayDate } from "../../libs/date";
import StationObservationTime from "../Station/Observation/StationObservationTime";
import { insertMissingTimeStampData } from '../../libs/localStorage';

@inject('stationStore', 'dataSeriesStore', 'parameterStore')
@observer
class AnalysisChart extends Component {
  static contextTypes = {
    notify: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
  };

  static propTypes = {
    params: PropTypes.object.isRequired,
    route: PropTypes.object.isRequired,
  };

  @observable filters = {
    station_id: null,
    series_id: null,
    date_from: moment().add(-7, 'days').format('YYYY-MM-DD'),
    date_to: moment().format('YYYY-MM-DD'),
    period: 'Point',
  };
  @observable station = {};
  @observable stations = [];
  @observable observations = [];
  @observable dataSeriesItems = [];
  @observable loading = false;
  @observable toInsertMissingData = insertMissingTimeStampData.get();
  @observable aggregationType = 1;
  @observable timeOffset = 0;

  constructor(props) {
    super(props);

    this.state = {
      height: window.innerHeight,
      // product: '',
      series: 1, // props.seriesList[0].id,   // TODO Check if list is empty
      from: moment().subtract(1, 'days').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),
      data: {
        data: [],
        categories: [],
        seriesData: [],
      },
      unit: '',
      titleText: '',
      options: null,
    };
  }

  componentWillMount() {
    const { notify } = this.context;
    const { params: { id }, stationStore, parameterStore } = this.props;

    if (!parameterStore.items.length) parameterStore.fetchItems();
    stationStore.fetchItems()
      .then(action(stations => {
        this.stations = stations.sort((a, b) => (a.name > b.name) ? 1 : -1);
        if (process.env.NODE_ENV !== 'production') {
          this.filters.station_id = 597;
          this.onChangeStationFilter({ target: { value: this.filters.station_id } });
          this.filters.series_id = 13060;
          this.filters.period = 'Daily';
          this.timeOffset = 0;
          this.aggregationType = 1;
        }
      }))
      .catch(notify.error);
  }

  @action reset(item) {
    if (!item) {
      return;
    }
    this.observations = item;
  }

  @action onChangeToInsertMissingData = e => {
    this.toInsertMissingData = !this.toInsertMissingData
    insertMissingTimeStampData.set((this.toInsertMissingData));
  };
  @action onChangeAggregationType = e => this.aggregationType = e.target.value;
  @action onChangeTimeOffset = e => this.timeOffset = e.target.value;
  @action onChangeStationFilter = (e) => {
    const { notify } = this.context;
    const { stationStore, dataSeriesStore, parameterStore } = this.props;
    const stationId = e.target.value;
    this.filters.station_id = stationId;
    stationStore.fetchDataSeries(stationId)
      .then(action(dataSeriesItems => {
        this.dataSeriesItems = dataSeriesItems
          .sort((a, b) => a.name > b.name ? 1 : -1)
          .map(item => (Object.assign(item, { parameter: parameterStore.findById(item.parameter_id) })));
      }))
      .catch(notify.error);
  }
  @action onChangePeriodFilter = (e) => this.filters.period = e.target.value;
  @action onChangeParameter = (e) => this.filters.parameterId = e.target.value;
  @action onChangeSeries = (e) => this.filters.series_id = e.target.value;
  @action onChangeDateFrom = (e) => this.filters.date_from = e.target.value;
  @action onChangeDateTo = (e) => this.filters.date_to = e.target.value;

  @action showObservations = (e) => {
    const { notify } = this.context;
    const { parameterStore } = this.props;
    e.preventDefault();

    const er = message => notify.error({ message });
    if (!this.filters.station_id) {
      return er('Station filter required');
    }
    if (!this.filters.series_id) {
      return er('Data Series filter required');
    }
    if (!this.filters.date_from) {
      return er('Start date filter required');
    }
    if (!this.filters.date_to) {
      return er('End date filter required');
    }

    let selectedParameterProperty = parameterStore.findById(this.dataSeriesItems.filter(item => item.id == this.filters.series_id)[0].parameter_id).property;
    let selectedParameterStartTime = this.dataSeriesItems.filter(item => item.id == this.filters.series_id)[0].start_time.split(':');

    this.setState({ options: null });
    this.loading = true;
    api.analysis
      .fetchAll(this.filters)
      .then((observations) => {
        observations.data = (() => {
          if (!observations.data || observations.data.length == 0) return observations.data;
          let groupedObservation = _.groupBy(observations.data, item => item.datetime);
          let uniqueObservations = [];
          Object.keys(groupedObservation).map(item => {
            uniqueObservations.push(groupedObservation[item][0])
          });
          return uniqueObservations;
        })();
        this.reset(observations);
        const parameter = this.dataSeriesItems.filter(item => item.name.toLowerCase() == observations.parameter_name.toLowerCase())[0];
        parameter && parameter.parameter_unit && parameter.parameter_unit.symbol ? this.setState({ unit: `${parameter.name} (${parameter.parameter_unit.symbol})` }) : this.setState({ unit: '' });

        const { date_from: dateFrom, date_to: dateTo, period: periodFilter } = this.filters;

        const titleText = `${observations.parameter_name} from ${dateFrom} to ${dateTo}`;

        const dataState = this.state.data;
        dataState.data = (
          observations.data && observations.data.map(observation => parseFloat(observation.value))
        ) || [];
        dataState.categories = (
          observations.data && observations.data.map(observation => observation.datetime)
        ) || [];

        let seriesData = this.insertMissingData((
          observations.data &&
          observations.data.map(({ datetime, value }) => {
            return [getDisplayDate(datetime, { returnMills: true }), value];
          })
        ) || []);

        seriesData = [[moment.utc(moment(this.filters.date_from).format('YYYY-MM-DDT00:00:00')).valueOf(), null], ...seriesData, [moment.utc(moment(this.filters.date_to).format('YYYY-MM-DDT23:59:59')).valueOf(), null]];

        let seriesOptions;

        if (periodFilter === 'Point') {
          seriesOptions = [{
            name: titleText,
            data: seriesData,
          }];
        } else {
          const resolvePeriodFormat = (p, date) => {
            switch (p) {
              // case 'Point': return 'YYYY-MM-DDTHH:mm:ss+00:00';
              case 'Minute':
                return 'YYYY-MM-DDTHH:mm:00+00:00';
              case 'Hourly':
                return 'YYYY-MM-DDTHH:00:00+00:00';
              case 'Daily':
                return 'YYYY-MM-DDT00:00:00+00:00';
              case 'Weekly':
                return 'YYYY-MM-DDT00:00:00+00:00';
              // case 'Weekly':  return 'YYYY-MM-DDTHH:00:00+00:00';
              // case 'Weekly': return 'gggg ww';
              case 'Monthly':
                return 'YYYY-MM-01T00:00:00+00:00';
              case 'Annual':
                return 'YYYY-01-01T00:00:00+00:00';
              default:
                return 'YYYY-MM-DDTHH:mm:ss+00:00';
            }
          };

          let timeUnit = (() => {
            switch (periodFilter) {
              case 'Minute': return 'minutes';
              case 'Hourly': return 'hours';
              case 'Daily': return 'days';
              case 'Monthly': return 'months';
              case 'Annual': return 'years';
              default: return null;
            }
          })();

          // const periodFormat = resolvePeriodFormat(periodFilter);

          const seriesDataPeriodic = _.groupBy(seriesData, item => {
            // return moment.utc(item[0]).format(resolvePeriodFormat(periodFilter))
            let aggregationTypeOffset = this.aggregationType === 1 ? 0 : 1;
            if (periodFilter == 'Daily') {
              let date = item[0],
                // hour = +moment.utc(date).format('HH'),
                hour = new Date(date).getUTCHours(),
                // minute = +moment.utc(date).format('mm'),
                minute = new Date(date).getUTCMinutes(),
                startHour = +selectedParameterStartTime[0],
                startMinute = +selectedParameterStartTime[1],
                offSetHour = Math.floor(moment().utcOffset() / 60),
                offSetMinute = moment().utcOffset() % 60,
                offsetBeforeStartTime = hour !== 0 && minute !== 0 && ((hour < (startHour)) || (hour == (startHour) && minute < (startMinute))) ? 1 : 0; // to adjust data before start hour

              return moment.utc(moment.utc(date).subtract(aggregationTypeOffset, 'seconds').subtract(offsetBeforeStartTime, 'days').format('YYYY-MM-DDT00:00:00+00:00')).add(startHour, 'hours').add(startMinute, 'minutes').add(1, timeUnit).subtract(this.timeOffset, 'minutes').format('YYYY-MM-DDTHH:mm:00+00:00');

            } else {
              return moment.utc(moment.utc(item[0]).subtract(aggregationTypeOffset, 'seconds').format(resolvePeriodFormat(periodFilter))).add(1, timeUnit).subtract(this.timeOffset, 'minutes').format('YYYY-MM-DDTHH:mm:00');
              // if (this.aggregationType === 1) return moment.utc(moment.utc(moment.utc(item[0])).format(resolvePeriodFormat(periodFilter))).add(1, timeUnit).subtract(this.timeOffset, 'minutes').format('YYYY-MM-DDTHH:mm:ss');
              // else {
              //   if (!timeUnit) return moment.utc(moment.utc(item[0])).add(1, timeUnit).subtract(this.timeOffset, 'minutes').format('YYYY-MM-DDTHH:mm:00');
              //   else {
              //     // console.log('asdf')
              //     return moment.utc(moment.utc(item[0]).subtract(1, 'seconds').format(resolvePeriodFormat(periodFilter))).add(1, timeUnit).subtract(this.timeOffset, 'minutes').format('YYYY-MM-DDTHH:mm:00');
              //   }
              // }
            }
          });

          // console.log(Object.keys(seriesDataPeriodic)[3], seriesDataPeriodic[Object.keys(seriesDataPeriodic)[3]].map(item => ([moment.utc(item[0]).format('YYYY-MM-DDTHH:mm:ss'), item[1]])))
          // console.log(Object.keys(seriesDataPeriodic)[2], seriesDataPeriodic[Object.keys(seriesDataPeriodic)[2]].map(item => item[1]).reduce((acc, val) => acc + val, 0))
          // console.log(seriesDataPeriodic[Object.keys(seriesDataPeriodic)[2]].map(item => item[1]))

          // Object.keys(seriesDataPeriodic).map(period => {
          //   console.log('period', period);
          //   seriesDataPeriodic[period].map(item => {
          //     console.log('\t', moment.utc(item[0]).format('YYYY-MM-DDTHH:mm:00+00:00'))
          //   });
          //   console.log();
          // });

          const max = {};
          const min = {};
          const mean = {};

          Object.keys(seriesDataPeriodic)
            .forEach(period => {
              // console.log('period', period);
              const periodData = seriesDataPeriodic[period].map(item => item[1]).filter(item => item != null && item !== '');
              // console.log('periodData', periodData);
              max[period] = _.max(periodData);
              min[period] = _.min(periodData);
              mean[period] = selectedParameterProperty === 'Continuous' ? (periodData.length !== 0 ? _.sum(periodData) / periodData.length : null) : _.sum(periodData);
            });

          const maxSeries = Object.keys(max)
            .map(period => ([moment.utc(period).valueOf(), max[period]]));
          const minSeries = Object.keys(min)
            .map(period => ([moment.utc(period).valueOf(), min[period]]));
          const meanSeries = Object.keys(mean)
            .map(period => ([moment.utc(period).valueOf(), mean[period]]));
          // const rangeSeries = Object.keys(mean).map(period => ([moment(period).valueOf(), min[period], max[period]]));

          if (selectedParameterProperty === 'Continuous') {
            // if(this.filters.period == 'Point'){
            seriesOptions = [
              {
                name: 'Max',
                data: maxSeries,
              },
              {
                name: 'Min',
                data: minSeries,
              },
              {
                name: 'Average',
                data: meanSeries,
              },
            ];
            // } else {
            //   seriesOptions = [{
            //     name: 'Average',
            //     data: meanSeries
            //   },{
            //     name: 'Range',
            //     type: 'arearange',
            //     lineWidth: '0',
            //     fillOpacity: '0.3',
            //     color: Highcharts.getOptions().colors[0],
            //     marker: {enabled: false},
            //     data: rangeSeries
            //   }]
            // }
          } else {
            seriesOptions = [{
              name: 'Accumulation',
              data: meanSeries,
            }]
          }
        }

        const options = {
          chart: {
            type: selectedParameterProperty == 'Continuous' ? 'line' : 'column',
            zoomType: 'x',
          },
          title: {
            text: titleText,
          },
          xAxis: {
            type: 'datetime',
            dateTimeLabelFormats: {
              second: '%H:%M:%S',
              minute: '%H:%M',
              hour: '%H:%M',
              day: '%Y-%m-%d',
              month: '%Y-%m',
              year: '%Y'
            },
          },
          yAxis: {
            title: {
              text: this.state.unit,
            },
          },
          tooltip: {
            crosshairs: true,
            shared: true,
          },
          series: seriesOptions,
        };

        this.loading = false;
        this.setState({
          data: dataState,
          titleText,
          seriesData,
          options,
        });
      })
      .catch(err => {
        console.log(err);
        notify.error(err);
        this.loading = false;
      });
  };

  insertMissingData = observation => {
    let dataSeries = this.dataSeriesItems.find(item => +item.id === +this.filters.series_id)
    let dataSeriesInterval = dataSeries && (dataSeries.interval || dataSeries.interval_1) * 60 * 1000;
    if (!this.toInsertMissingData || !dataSeriesInterval) return observation;
    else {
      let data = [];
      let timeCounter = observation[0][0], endTime = observation[observation.length - 1][0];
      while (timeCounter <= endTime) {
        // eslint-disable-next-line
        let item = observation.find(item => Math.floor(item[0] / dataSeriesInterval) * dataSeriesInterval === Math.floor(timeCounter / dataSeriesInterval) * dataSeriesInterval);
        if (item) data.push(item);
        else data.push([timeCounter, null]);
        timeCounter += dataSeriesInterval;
      }
      return data;
    }
  }

  exportCSV = (e) => {
    e.preventDefault();
    if (!this.state.options) return;

    const series = this.state.options.series;
    let { station_id, series_id, date_from, date_to, period } = this.filters;
    // let selectedParameterProperty = this.props.parameterStore.findById(this.dataSeriesItems.filter(item => item.id == series_id)[0].parameter_id).property;
    // console.log(series)
    let textToSave = '';
    let data = series[0].data;

    if (this.filters.period === 'Point') {
      textToSave = 'dateTime,value\n';
      data.map((d, index) => {
        let datetime = moment.utc(d[0]).format('MM/DD/YYYY HH:mm:00'),
          value = !!d[1] || d[1] === 0 ? d[1] : '';
        textToSave = textToSave.concat(datetime + ', ' + value + '\n');
      });
    } else {
      // if(selectedParameterProperty == 'Continuous'){
      //   textToSave = 'datetime, Average, Min, Max\n';
      //   series[0].data.map(item => {
      //     let range = series[1].data.filter(x => x[0] == item[0])[0];
      //     textToSave = textToSave.concat([
      //       moment(item[0]).format('YYYY-MM-DD HH:mm:ss'), item[1],
      //       range[1], range[2], '\n'
      //     ].join(', '))
      //   })
      // } else {
      let format = (() => {
        switch (this.filters.period) {
          case 'Hourly': return 'MM/DD/YYYY HH:mm';
          case 'Daily': return 'MM/DD/YYYY';
          case 'Monthly': return 'MM/YYYY';
          case 'Annual': return 'YYYY';
          default: return 'MM/DD/YYYY HH:mm:ss';
        }
      })();


      textToSave = 'datetime, ' + series.map(item => item.name).join(', ') + '\n';
      data.map(item => {
        let textArr = [moment.utc(item[0]).format(format), item[1]];
        series.map((itemx, index) => {
          if (index > 0) {
            textArr.push(itemx.data.filter(x => x[0] == item[0])[0][1])
          }
        });
        textArr.push('\n');
        textToSave = textToSave.concat(textArr.join(', '));
      });
      // }
    }
    let hiddenElement = document.createElement('a');
    let csvData = new Blob([textToSave], { type: 'text/csv' });
    hiddenElement.href = URL.createObjectURL(csvData);
    // hiddenElement.href = 'data:attachment/text,' + encodeURI(textToSave);
    hiddenElement.target = '_blank';
    hiddenElement.download = [
      this.stations.filter(item => item.id == station_id)[0].name,
      this.dataSeriesItems.filter(item => item.id == series_id)[0].name,
      date_from, date_to, period
    ].join('_') + '.csv';
    hiddenElement.click();
  };

  render() {
    const { seriesData, options } = this.state;
    const { stationStore, parameterStore } = this.props;
    // console.log(this.dataSeriesItems)
    return (
      <div>
        <Form>
          <FormBody>
            <SelectInput
              label={'Station'}
              value={this.filters.station_id}
              fields={{ label: 'name', value: 'id' }}
              options={this.stations}
              onChange={this.onChangeStationFilter}
              filterOptions={stationStore.filterStations}
            />
            <SelectInput
              label={'Data Series'}
              value={this.filters.series_id}
              fields={{ label: 'name', value: 'id' }}
              options={this.dataSeriesItems}
              onChange={this.onChangeSeries}
              filterOptions={(options, filterText) => parameterStore.filterParameters(options, filterText, 'parameter.code')}
            />
            <DateInput
              label={'Date From'}
              value={this.filters.date_from}
              onChange={this.onChangeDateFrom}
            />
            <DateInput
              label={'Date To'}
              value={this.filters.date_to}
              onChange={this.onChangeDateTo}
            />
            <SelectInput
              label={'Period'}
              value={this.filters.period}
              fields={{ label: 'name', value: 'name' }}
              options={[
                { name: 'Point' },
                { name: 'Minute' },
                { name: 'Hourly' },
                { name: 'Daily' },
                { name: 'Weekly' },
                { name: 'Monthly' },
                { name: 'Annual' },
              ]}
              onChange={this.onChangePeriodFilter}
            />
            <SelectInput
              label={'Aggregation type'}
              value={this.aggregationType}
              fields={{ label: 'name', value: 'value' }}
              options={[
                { name: 'Left Closed Right Open', value: 1 },
                { name: 'Left Open Right Closed', value: 2 },
              ]}
              onChange={this.onChangeAggregationType}
            />
            <TextInput label={'Time Offset'} value={this.timeOffset} onChange={this.onChangeTimeOffset} type={'number'} inputProps={{ min: 0 }} />
            <div className='formInput'>
              <label>Insert timestamp for missing data</label>
              <input type="checkbox" checked={this.toInsertMissingData} onChange={this.onChangeToInsertMissingData} />
            </div>
          </FormBody>
          <FormActions>
            <button onClick={this.showObservations}>View</button>
            <button onClick={this.exportCSV}>Download CSV</button>
          </FormActions>
        </Form>

        <div>
          {this.loading && <Spinner />}
          {!this.loading && options && (process.env.NODE_ENV !== 'production' ?
            <StationObservationTime data={options.series[0].data} property={'text'} /> :
            <GraphView options={options} />)}
        </div>

      </div>
    );
  }
}

export default AnalysisChart;



// WEBPACK FOOTER //
// ./src/components/Analysis/AnalysisChart.js